import { getCertList } from "@/services";
import { useMount } from "ahooks";
import { AutoComplete, type AutoCompleteProps } from "antd";
import { uniqBy } from "lodash";
import { useState } from "react";

interface ICertSubjectSelectProps extends Omit<AutoCompleteProps, "onSelect"> {
  onSelect?: (subject: CERTSubject) => void;
  type?: "company" | "personal";
}

export function CertSubjectSelect({
  onSelect,
  type,
  ...props
}: ICertSubjectSelectProps) {
  const [options, setOptions] = useState<CERTSubject[]>([]);

  useMount(() => {
    getCertList({ page_size: 200 }).then((res) => {
      if (res.list && res.list.length > 0) {
        const list = uniqBy(res.list, (item) => item.subject_info.name).filter(
          (item) => item.subject_info.name && item.subject_info.type === type
        );
        setOptions(list);
      } else {
        setOptions([]);
      }
    });
  });

  return (
    <AutoComplete
      options={options.map((item) => {
        return {
          value: item?.subject_info?.name,
          subject: item,
        };
      })}
      onSelect={(value, option) => onSelect?.(option.subject)}
      filterOption={(inputValue, option) =>
        option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
      getPopupContainer={(triggerNode) => triggerNode}
      maxLength={100}
      allowClear
      {...props}
    />
  );
}
